import CustomerHeaderSectionImage1 from '../../assets/customer_header_section_image1.png';
import { FrameLayout, useResponsivePadding, VerticalLayout } from '../../common/common-layout';
import { SubH1 } from '../../common/common-text';
import { pxToRem } from '../../common/utils/ConvertUtils';
import '../../css/bbpage.css';
import { useDeviceType } from '../../hooks/useDeviceType';

const CustomerHeaderSection = () => {
  const { horizontal: padding } = useResponsivePadding(/*{ mode: 'fixed' }*/);
  const { isMobile } = useDeviceType();

  return (
    <VerticalLayout style={{
      background: '#81817f',
      width: '100%',
      ...(!isMobile ? { aspectRatio: '1920 / 600' } : {}),
    }} wrapContents={true}>
      <FrameLayout
        style={{
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        {/* 이미지 */}
        <img
          src={CustomerHeaderSectionImage1}
          style={{
            width: '100%',
            height: isMobile ? '290px' : 'auto',
            objectFit: 'cover',
            objectPosition: 'center',
            display: 'block',
          }}
        />

        {/* 딤 처리 오버레이 */}
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background: 'rgba(0, 0, 0, 0.2)',
            zIndex: 1,
          }}
        />

        {/* 텍스트 */}
        <SubH1
          style={{
            color: 'white',
            position: 'absolute',
            bottom: isMobile ? 26 : `${pxToRem(80)}`,
            left: `${padding}px`,
            zIndex: 2,
          }}
        >
          Customer Support
        </SubH1>
      </FrameLayout>
    </VerticalLayout>
  );
};

export default CustomerHeaderSection;
